export const environment = {
  production: false,
  apiUrl: 'https://api.studentformsadmin-dev.athabascau.ca',
  envName: 'DEVELOPMENT',
  authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_NDJWFeX1P',
  clientId: '4v57bjuhrqnps0mg237ktsqq5r',
  scope: 'email openid profile',
  responseType: 'code',
};
